/**
 * Landing pages whose content is editable from the admin
 * ("Landing Geral" → Conteúdo da Landing).
 *
 * `slug` is the key used in the `landing_pages` table.
 * `kind` tells which fields the page actually renders:
 *  - "hub": full structure (Lagoa / Ipanema hubs)
 *  - "semantic": hero + seções de texto + FAQ
 */
export interface EditableLandingPage {
  slug: string;
  label: string;
  path: string;
  kind: "hub" | "semantic";
}

export const EDITABLE_LANDING_PAGES: EditableLandingPage[] = [
  {
    slug: "apartamentos-exclusivos-vista-lagoa-rodrigo-de-freitas-rj",
    label: "Lagoa — Apartamentos com Vista para a Lagoa",
    path: "/lagoa/apartamentos-exclusivos-vista-lagoa-rodrigo-de-freitas-rj",
    kind: "hub",
  },
  {
    slug: "melhores-imoveis-de-ipanema",
    label: "Ipanema — Apartamentos, Studios e Cobertura",
    path: "/ipanema/melhores-imoveis-de-ipanema",
    kind: "hub",
  },
  {
    slug: "imoveis-de-luxo-na-lagoa",
    label: "Imóveis de Luxo na Lagoa",
    path: "/imoveis-de-luxo-na-lagoa",
    kind: "semantic",
  },
  {
    slug: "apartamentos-4-quartos-ipanema",
    label: "Apartamentos de 4 Quartos em Ipanema",
    path: "/apartamentos-4-quartos-ipanema",
    kind: "semantic",
  },
  {
    slug: "studios-airbnb-copacabana",
    label: "Studios para Airbnb em Copacabana",
    path: "/studios-airbnb-copacabana",
    kind: "semantic",
  },
];
